 /**
 * Arlo SFCC Static
 * Security NPI Page entry point.
 */

// import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import AwardSlider from './components/npi/AwardSlider';
import SecureShopping from './components/npi/SecureShopping';
import BundleCarousel from './components/npi/BundleCarousel';
import FeaturedReviews from './components/npi/FeaturedReviews';
import ProductRecommendations from './components/npi/ProductRecommendations';
import ProductInfoVideo from './components/npi/ProductInfoVideo';
import ProductFullWidth from './components/npi/ProductFullWidth';
import ProductNav from './components/npi/ProductNav';
import EmailInputModal from './components/npi/EmailInputModal';
import ProductMedia from './components/npi/ProductMedia';
import BackToTop from './components/npi/BackToTop';
import BundleList from './components/npi/BundleList';
import AddonCard from './components/npi/AddonCard';
import MouseOverFeatures from './components/npi/MouseOverFeatures';
import GalleryStack from './components/npi/GalleryStack';
import MasonryFeature from './components/MasonryFeature';

/**
 * Function to delay loading until jquery is available.
 * @param {function} method - init function
 */
function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function () {
            defer(method);
        }, 50);
    }
}

defer(function () {
    new AwardSlider(); // eslint-disable-line no-new
    new BundleCarousel(); // eslint-disable-line no-new
    new FeaturedReviews(); // eslint-disable-line no-new
    new ProductRecommendations(); // eslint-disable-line no-new
    new ProductInfoVideo('info-video-container'); // eslint-disable-line no-new
    new ProductFullWidth(); // eslint-disable-line no-new
    new ProductNav(); // eslint-disable-line no-new
    new EmailInputModal('notify-container'); // eslint-disable-line no-new
    new ProductMedia(); // eslint-disable-line no-new
    new BackToTop(); // eslint-disable-line no-new
    new BundleList(); // eslint-disable-line no-new
    new AddonCard(); // eslint-disable-line no-new
    new SecureShopping(); // eslint-disable-line no-new
    new MouseOverFeatures(); // eslint-disable-line no-new
    new GalleryStack(); // eslint-disable-line no-new
    new MasonryFeature(); // eslint-disable-line no-new

    // PARALLAX EFFECT
    if (window.matchMedia('(min-width: 992px)').matches) {
        const detailModule = $('#detailModule');
        const carouselHeight = $('.product-overview__gallery-slides').height();
        const detailsHeight = $('.product-overview__detail-wrap').height();

        if (carouselHeight <= detailsHeight) {
            detailModule.height(carouselHeight);
        } else {
            detailModule.css('overflow-y', 'auto');
        }
    }

    // Page Follow Links

    const faqFollow = $('#faqLink');
    const faqSection = $('.faq--pdp');

    if (faqFollow) {
        faqFollow.on('click', (event) => {
            event.preventDefault();
            const duration = 1000;

            if (faqSection) {
                const top = faqSection.offset().top;
                $('html, body').animate({ scrollTop: top }, duration);
            }

            return false;
        });
    }

    const specFollow = $('#specsLink');
    const specSection = $('.faq--specs');

    if (specFollow) {
        specFollow.on('click', (event) => {
            event.preventDefault();
            const duration = 1000;

            if (specSection) {
                const top = specSection.offset().top;
                $('html, body').animate({ scrollTop: top }, duration);
            }

            return false;
        });
    }
});

